import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";

function EditarMedioPublicitario() {

    const queryParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    
    const [nombre, setNombre] = useState('');

    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        axios.get('/medio-publicitario',config2)
            .then(response => {
                setNombre(response.data[0].nombre);
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const data = {
            uid: userdata.user_id,
            id: id,
            nombre: nombre
        };

        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        };
        
        axios.put('/medio-publicitario', data, config)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg','El Medio Publicitario "'+nombre+'" Ha Sido Modificado');
                    history.push('/medios-publicitarios');
                }
            )
            .catch(
                err => {
                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/medios-publicitarios">Medios Publicitarios</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Editar Medio Publicitario</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Medio Publicitario</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-12">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                        <form id="role-form" onSubmit={handleSubmit}>
                                            <div className="row align-items-end">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="nombre">Nombre</label>
                                                        <input type="text" name="nombre" className="form-control" id="nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} required disabled={loading} />
                                                        {errorlist.nombre && (
                                                            <div className="invalid-feedback visible">
                                                            {errorlist.nombre}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <div className="d-flex gap-2">
                                                            <Link to="/medios-publicitarios" className="btn btn-secondary">
                                                                Cancelar
                                                            </Link>
                                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                                Guardar Cambios&nbsp;
                                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarMedioPublicitario;